var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 18,
    viewBox: "0 0 29 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.156 8.121 21.368.896C20.908.482 20.025.311 19.51.79c-.506.47-.491 1.386.013 1.86l4.773 5.073H1.773a1.274 1.274 0 1 0 0 2.55h22.524l-4.773 5.073c-.434.436-.514 1.383-.013 1.86.502.477 1.415.324 1.857-.107l6.788-7.224q.345-.37.344-.877c-.012-.304-.137-.656-.344-.877"
  })));
};
export default SvgArrowRight;